import { render, staticRenderFns } from "./icon-play.vue?vue&type=template&id=1c2e3f80&scoped=true&"
import script from "./icon-play.vue?vue&type=script&lang=js&"
export * from "./icon-play.vue?vue&type=script&lang=js&"
import style0 from "./icon-play.vue?vue&type=style&index=0&id=1c2e3f80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2e3f80",
  null
  
)

export default component.exports